import { useCallback, useState } from 'react';

export function useFormFields(initial) {
  const [form, setForm] = useState(initial);
  // Functional updates use current state without capturing the form object.
  const setField = useCallback((key, value) => {
    setForm(current => ({ ...current, [key]: value }));
  }, []);
  const bind = key => ({ value: form[key], onChange: event => setField(key, event.target.value) });
  return { form, setField, bind };
}